module.exports = "<RadioButtonGroup name=\"shipSpeed\" defaultSelected=\"not_light\">\n<RadioButton\n  value=\"light\"\n  label=\"prepare for light speed\"\n  style={{marginBottom:16}} />\n<RadioButton\n  value=\"not_light\"\n  label=\"light speed too slow\"\n  style={{marginBottom:16}}/>\n<RadioButton\n  value=\"ludicrous\"\n  label=\"go to ludicrous speed\"\n  style={{marginBottom:16}}\n  disabled={true}/>\n</RadioButtonGroup>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/radio-buttons-code.txt
 ** module id = 856
 ** module chunks = 0
 **/